<template>
  <div class="dynamic-attr-text" :class="(attrObj.isCheckError?'is-check-error':'')">
    <div
      :class="'dynamic-attr-text-title '+ (attrObj.mustFlag=='1'?'is-item-required':'')"
      :style="{fontSize:$pScreen.titleS}"
    >
      <span>{{ showNum(attrObj, currentPage) }} {{ attrObj.title }}</span>
    </div>
    <div
      class="text-item-value text-item-input"
      :style="{'margin-bottom': attrObj.isCheckError ? '0' : '15px'}"
    >
      <Input
        v-if="!phoneFlag"
        v-model="attrObj.answerContent"
        size="default"
        :disabled="attrObj.disabled"
        placeholder="请输入你的手机号"
        @on-blur="blur" />

      <div v-if="phoneFlag" class="flex">
        <Input
          v-model="attrObj.answerContent"
          size="default"
          :disabled="attrObj.disabled"
          placeholder="请输入你的手机号"
          :style="{width: (verificationFlag && !attrObj.disabled) ? '70%' : '100%'}" 
           @on-blur="phoneBlur" />
        <Button v-if="verificationFlag && !attrObj.disabled" class="action" :disabled="codeDisabled" @click="getVerificationCode">{{codeMsg}}</Button>
      </div>

      <div v-if="verificationFlag && !attrObj.disabled" class="flex" style="margin-top: 20px; justify-content: flex-start;">
        <span style="width: 60px;">验证码</span>
        <Input
          v-model="attrObj.verificationCode"
          size="default"
          :disabled="attrObj.disabled"
          style="width: 30%;"
          @on-blur="verificationBlur" />
      </div>

      <div v-if="attrObj.isCheckError" class="errorTip">{{ attrObj.errorMsg || errorMsg }}</div>
    </div>
  </div>
</template>

<style scoped>
  .dynamic-attr-text .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }
  .dynamic-attr-text .action {
    width: fit-content;
    margin-left: 10px;
    font-size: 12px;
    text-align: center;
    border: 1px solid #dcdee2 !important;
    border-radius: 8px;
    background: #fff;
    color: #333;
  }
  .dynamic-attr-text .action:focus, .dynamic-attr-text .action:disabled, .dynamic-attr-text .action:active {
    background: #fff;
    color: #333;
  }
  .text-item-value {
    margin-top: 5px;
  }
</style>
<script>
import { FormType } from '../../../../commons/commonVariables.js';
export default {
  props: {
    attrObj: Object,
    currentPage: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      phoneFlag: false,
      verificationFlag: false,
      errorMsg: '请输入你的手机号',
      codeDisabled: false,
      countdown: 60,
      codeMsg: '获取验证码',
      timer: null
    }
  },
  created() {},
  //初始化后调用
  mounted: function() {
    const phoneNumberVerification = this.attrObj.phoneNumberVerification && this.attrObj.phoneNumberVerification.toString();
    switch(phoneNumberVerification){
      case '1':
        this.phoneFlag = true;
        break;
      case '2':
        this.phoneFlag = true;
        this.verificationFlag = true;
        break;
      default:
        this.phoneFlag = false;
    }
  },
  methods: {
    // 只有趣味表单才展示题号
    showNum(item, current){
      if(item.formType !== FormType.interestForm){
        return ''
      } else {
        return `${current + 1}.`
      } 
    },
    getVerificationCode(){
      if (this.attrObj.answerContent && this.attrObj.answerContent.trim()) {
        if(!(/^1[0-9]{10}$/.test(this.attrObj.answerContent))){
          this.$set(this.attrObj, "isCheckError", true);
          this.errorMsg = '请输入正确的手机号';
          return;
        }else{
          this.$set(this.attrObj, "isCheckError", false);
        }
      } else {
        this.$set(this.attrObj, "isCheckError", true);
        this.errorMsg = '请输入你的手机号';
        return;
      }
      this.myCountdown();
      const params = new FormData();
      params.append("phoneNum", this.attrObj.answerContent);
      this.$api.post({
        sc: "mobileMarketing",
        params: params,
        url: "h5/questionActivity/sendMessage",
        success: r => {
          if(r && r.result){
            this.attrObj.redisKey = r.result.redisKey
          }
        }
      })
    },
    myCountdown() {
      // 验证码60秒倒计时
      if (!this.timer) {
        this.codeDisabled = true;
        this.timer = setInterval(() => {
          if (this.countdown > 0 && this.countdown <= 60) {
            this.countdown--;
            if (this.countdown !== 0) {
              this.codeMsg = this.countdown + " S";
            } else {
              clearInterval(this.timer);
              this.codeMsg = "重新获取";
              this.countdown = 60;
              this.timer = null;
              this.codeDisabled = false;
            }
          }
        }, 1000)
      }
    },
    blur() {
      if (this.attrObj.mustFlag=='1') {
        if (this.attrObj.answerContent && this.attrObj.answerContent.trim()) {
          this.$set(this.attrObj, "isCheckError", false);
        } else {
          this.$set(this.attrObj, "isCheckError", true);
        }
      }
    },
    phoneBlur(){
      if (this.attrObj.answerContent && this.attrObj.answerContent.trim()) {
        if(!(/^1[0-9]{10}$/.test(this.attrObj.answerContent))){
          this.$set(this.attrObj, "isCheckError", true);
          this.errorMsg = '请输入正确的手机号'
        }else{
          this.$set(this.attrObj, "isCheckError", false);
        }
      } else {
        this.$set(this.attrObj, "isCheckError", true);
        this.errorMsg = '请输入你的手机号'
      }
    },
    verificationBlur(){
      if (this.attrObj.verificationCode && this.attrObj.verificationCode.trim()) {
        this.$set(this.attrObj, "isCheckError", false);
      } else {
        this.$set(this.attrObj, "isCheckError", true);
        this.errorMsg = '请输入验证码'
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/phoneText.vue